<template>
    <v-card height="100%" class="d-flex flex-column pa-2">
        <v-card-text class="report-data py-4 px-0 text-center">
            {{ data ?? '-' }}
            <v-tooltip v-if="infoData" bottom>
                <template #activator="{ on }">
                    <v-icon
                        v-on="on"
                        small
                        color="rgba(0,0,0,.6)"
                    >
                        mdi-information-outline
                    </v-icon>
                </template>
                <p>{{ infoData }}</p>
            </v-tooltip>
        </v-card-text>
        <v-card-actions class="mt-auto report-title">
            {{ title }}
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: "ReportDataCard",

    props: {
        data: {
            required: true,
        },
        title: {
            required: true,
        },
        infoData: {
            default: '',
        },
    },
}
</script>

<style scoped>
.report-title {
    font-size: 12px;
    color: rgba(0,0,0,.6);
}

.report-data {
    font-size: 30px;
    color: black;
}
</style>
